/**
 * The same paper-and-ink scheme as the 2D editor, so the board reads as the
 * same instrument in a different room.
 */
export const palette = {
  paper: "#f7f4ea",
  paperEdge: "#c9c2ae",
  ink: "#1f1d1a",
  construction: "#b3ac9d",
  highlight: "#2563eb",
  preview: "#3b82f6",
  label: "#5b5648",
  panel: "#26231e",
  panelEdge: "#4a453c",
  panelText: "#e8e4d8",
  panelMuted: "#97907f",
  button: "#33302a",
  buttonEdge: "#4a453c",
  buttonHover: "#403c34",
  buttonActive: "#7c6f4f",
  error: "#ef4444",
};
